import React from 'react'
import './ClinicName.scss'

const ClinicName = ({ name, clinicNum }) => (
  <div className="ClinicName">
    <div className="clinic-number">{clinicNum}</div>
    <h3>{name}</h3>
  </div>
)

export default ClinicName
